import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/auth/signin';
import {signIn} from '../../../reducers/modals/actions';
import BlueButton from '../../components/blue-button';
import FormInput from '../../components/form-input';
import {useState} from 'react';
import ModalsLib from '../../../lib/modals';

import Triggers from '../../../lib/triggers';

export default () => {
    const {data} = useSelector(Selector),
          dispatch = useDispatch();

    const [username, setUsername] = useState(""),
          [password, setPassword] = useState("");

    useEffect(() => {
        Triggers.modal_open({
            modal: "signin"
        });
    }, []);

    return (
        <div className="modal auth animate__animated animate__fadeInUp animate__faster">
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">Sign In</div>
                    <div className="descriptions">Log in to your account to earn big winnings!</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                {data.error && (
                    <div class="modal-message warning">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <span dangerouslySetInnerHTML={{__html: data.error}}></span>
                    </div>
                )}
                <div className="form-group">
                    <FormInput
                        name="username"
                        type={'text'}
                        label={null}
                        placeholder={'Username or Email'}
                        validators={[]}
                        defaultValue={username}
                        onChange={({value, validator}) => {
                            setUsername(value.replace(/[^a-z0-9_@.]/gi, '')); 
                        }} />

                    <FormInput
                        name="password"
                        type={'password'}
                        defaultValue={password}
                        label={null}
                        placeholder={'Password'}
                        validators={[]}
                        onChange={({value, validator}) => {
                            setPassword(value)
                        }} />

                        <div className="forget-password-block">
                            <span onClick={e => ModalsLib.open('account-recovery')}>Forget password?</span>
                        </div>
                </div>
                
            </div>

            <div className="modal-footer">
                <BlueButton active={data.button} onClick={e => {
                    dispatch(signIn({
                        username,
                        password
                    }));
                }}>
                    Sign In
                </BlueButton>
                <div className="auth-text">
                    Don't have an account? <span onClick={e => ModalsLib.open('signup')}>Sign Up</span>
                </div>
            </div>

            {/* <div className="network-methods">
                <div className="line">
                    <hr/>
                    <span>QUICK AUTH</span>
                    <hr/>
                </div>

                <div className="social-methods">
                    <div className="method"></div>
                    <div className="method"></div>
                    <div className="method"></div>
                    <div className="method"></div>
                </div>
            </div> */}
        </div>
    )
}